const translations = {
  title: "People Directory",
  subtitle:
    "Customers, firms, karigars, employees and vendors — one clean registry for the whole shop.",
  tab_customers: "Customers",
  tab_firms: "Firms",
  tab_karigars: "Karigars / Workers",
  tab_employees: "Employees",
  tab_vendors: "Vendors / Outside Workers",
  tab_kyc: "KYC Documents",
  searchPlaceholder: "Search by name, phone, work type…",
  add_customer: "Add Customer",
  add_firm: "Add Firm",
  add_karigar: "Add Karigar / Worker",
  add_employee: "Add Employee",
  add_vendor: "Add Vendor",
  no_records: "No records yet. Use the buttons above to add one.",
  inactive: "Inactive",
  kyc_incomplete: "KYC incomplete",
  kyc_complete: "KYC complete",
  view: "View",
  edit: "Edit",
  mark_inactive: "Mark inactive",
  mark_active: "Mark active",
  add_person_first: "Add a person first to manage their KYC documents.",
  on_file: "On file (paper register)",
  not_on_file: "Not on file",
  selected_title: "Selected Person",
  selected_placeholder:
    "Tap a row on the left to see their profile here. This same card will auto-fill in Orders, Billing, Repair, Issue Gold and Worker Settlement.",
  file_upload_title: "File upload coming later",
  file_upload_desc:
    "File upload storage will be enabled in a future version. For the pilot, attach physical files to the corresponding paper register and tick the box here once filed.",
  ok: "OK",
  lbl_phone: "Phone",
  lbl_altPhone: "Alt phone",
  lbl_address: "Address",
  lbl_aadhaar: "Aadhaar",
  lbl_pan: "PAN",
  lbl_gstin: "GSTIN",
  lbl_workType: "Work / Role",
  lbl_joiningDate: "Joined",
  lbl_status: "Status",
  lbl_kyc: "KYC",
  lbl_active: "Active",
  lbl_inactive: "Inactive",
  lbl_complete: "Complete",
  lbl_incomplete: "Incomplete",
  btn_edit: "Edit",
  btn_print_kyc: "Print KYC Sheet",
  btn_view_ledger: "View Ledger",
  btn_create_order: "Create Order",
  btn_photos_files: "Photos / Files",
};

export default translations;
